import { DatePipe } from '@angular/common';
import { isDefined, noUndefined } from '@angular/compiler/src/util';
import {
  AfterViewInit,
  Component,
  OnInit,
  Renderer2,
  ViewChild,
} from '@angular/core';
import {
  formatDate,
  MbscCalendarEvent,
  MbscEventcalendarOptions,
  MbscEventcalendarView,
  MbscPopup,
  MbscPopupOptions,
  momentTimezone,
} from '@mobiscroll/angular';
import { NgxSpinnerService } from 'ngx-spinner';
import { WORKING_TIME_CONFIG } from 'src/app/config/calendar.config';
import { AppointmentService } from 'src/app/services/appointment.service';
import { AuthenticationService } from 'src/app/services/authentication.service';

@Component({
  selector: 'app-diag-availabilty',
  templateUrl: './diag-availabilty.component.html',
  styleUrls: ['./diag-availabilty.component.scss'],
})
export class DiagAvailabiltyComponent implements OnInit {
  @ViewChild('popup', { static: false })
  popup!: MbscPopup;
  isEdit = false;
  popupHeader!: string;
  diagnoLocationId: any;
  shiftLength!: number;
  appointments: any;
  show: boolean = false;
  tempShift!: MbscCalendarEvent;

  constructor(
    private auth: AuthenticationService,
    public datepipe: DatePipe,
    private appointmentService: AppointmentService,
    private spinner: NgxSpinnerService,
    private renderer: Renderer2
  ) {}
  popupEditButtons = [
    'cancel',
    {
      handler: () => {
        this.deleteShift(this.tempShift);
        this.popup.close();
      },
      keyCode: 'enter',
      text: 'Delete',
      cssClass: 'btn btn-danger',
    },
  ];

  popupButtons: any = [];
  defaultShift(args: any): any {
    const d = args.start;
    const start = args.start; //new Date(d.getFullYear(), d.getMonth(), d.getDate(), args.slot === 1 ? 9 : 13);
    const end = new Date(new Date(start).setHours(start.getHours() + 1)); //new Date(d.getFullYear(), d.getMonth(), d.getDate(), args.slot === 1 ? 13 : 17);

    return {
      title: 'Available',
      start,
      end,
      resource: args.resource,
    };
  }

  popupOptions: MbscPopupOptions = {
    display: 'bottom',
    contentPadding: false,
    fullScreen: true,
    onClose: () => {
      if (!this.isEdit) {
        this.diagnoShifts = [...this.diagnoShifts];
      }
    },
    responsive: {
      medium: {
        display: 'center',
        width: 250,
        fullScreen: false,
        touchUi: false,
        showOverlay: true,
        closeOnOverlayClick: false,
        closeOnEsc: false,
      },
    },
  };
  diagnoView: MbscEventcalendarView = {
    schedule: {
      type: 'week',
      //  eventList: true,
      allDay: false,
      startDay: 1,
      endDay: 7,
      startTime: WORKING_TIME_CONFIG.start,
      endTime: WORKING_TIME_CONFIG.end,
      // startDay: 1,
      // endDay: 5,
    },
  };
  diagnoShifts: MbscCalendarEvent[] = [];
  resource: any[] = [];

  slots = [
    {
      id: 1,
      name: 'Morning1',
      startTime: '09:00',
      endTime: '10:00',
    },
    {
      id: 2,
      name: 'Morning2',
      startTime: '10:00',
      endTime: '11:00',
    },
    {
      id: 3,
      name: 'Morning3',
      startTime: '11:00',
      endTime: '12:00',
    },
    {
      id: 4,
      name: 'Morning4',
      startTime: '12:00',
      endTime: '13:00',
    },
    {
      id: 5,
      name: 'Morning5',
      startTime: '13:00',
      endTime: '14:00',
    },
    {
      id: 6,
      name: 'Morning6',
      startTime: '14:00',
      endTime: '15:00',
    },
    {
      id: 7,
      name: 'Morning7',
      startTime: '15:00',
      endTime: '16:00',
    },
    {
      id: 8,
      name: 'Afternoon8',
      startTime: '16:00',
      endTime: '17:00',
    },
    {
      id: 9,
      name: 'Afternoon9',
      startTime: '17:00',
      endTime: '18:00',
    },
    {
      id: 10,
      name: 'Afternoon10',
      startTime: '18:00',
      endTime: '19:00',
    },
    {
      id: 11,
      name: 'Afternoon11',
      startTime: '19:00',
      endTime: '20:00',
    },
    {
      id: 12,
      name: 'Afternoon12',
      startTime: '20:00',
      endTime: '21:00',
    },
  ];

  diagnoTimelineOptions: MbscEventcalendarOptions = {
    min: new Date(), // set the minimum date to today
    onEventCreated: (args: any) => {
      setTimeout(() => {
        jQuery('body').addClass('timeline-event-created');
        jQuery('#diagnoSetAvailabilitySubmit').addClass('green');
        jQuery('#diagnoSetAvailabilitySubmit').removeClass(
          'grey pointer-disable'
        );
        jQuery('#diagnoSetAvailabilityClose').removeClass('pointer-disable');
        const shift: any = args.event;
        const start: any = shift.start;
        console.log(shift.slot);
        const slot: any = this.slots.find((s) => s.id === shift.slot);
        this.tempShift = args.event;
        this.addShift(args.event);
      });
    },
    onEventClick: (args: any) => {
      jQuery('body').addClass('timeline-event-created');
      jQuery('#diagnoSetAvailabilitySubmit').addClass('green');
      jQuery('#diagnoSetAvailabilitySubmit').removeClass(
        'grey pointer-disable'
      );
      jQuery('#diagnoSetAvailabilityClose').removeClass('pointer-disable');
      const shift: any = args;
      const slot: any = this.slots.find((s) => s.id === shift.slot);
      this.isEdit = true;
      this.tempShift = args.event;

      // set popup options
      this.popupButtons = this.popupEditButtons;
      this.popupHeader =
        formatDate('MM/DD/YYYY', new Date(shift.date)) + '<br>'; //+ slot.name + ' Shift';

      this.popup.open();
    },
    onEventDeleted: (args) => {
      this.deleteShift(args.event);
    },

    clickToCreate: 'single',
    dragToMove: false,
    dragToCreate: false,
    dragToResize: false,
    timezonePlugin: momentTimezone,
    dataTimezone: 'utc',
    displayTimezone: 'America/Chicago',
    view: {
      schedule: {
        type: 'week',
        allDay: false,
        // startDay: 1,
        // endDay: 5
      },
    },

    slots: this.slots,
  };
  invalid: any = [];

  ngOnInit(): void {
    this.spinner.show();
    this.diagnoLocationId = this.auth.getUserLocationId();

    let userType = 1004;
    // if (this.userRole != 'DIRECTOR') {
    //   userType = 1004;
    // }else  if (this.userRole != 'DIAGNOSTIC') {
    //   userType = 1002;
    // }
    let diagno = {
      name: this.auth.getUserFullName(),
      id: this.auth.getUserId(),
    };
    this.resource.push(diagno);

    this.appointmentService
      .getOriginalDiagUnavailability(this.auth.getUserId(), null, userType)
      .subscribe((res) => {
        // this.shifts = res
        this.diagnoShifts = res.data;
        this.shiftLength = this.diagnoShifts.length;
        this.appointmentService
          .getAppointments(
            this.diagnoLocationId,
            this.auth.getUserId(),
            'ALL',
            null,
            null,
            null
          )
          .subscribe((res) => {
            this.appointments = res.data;
            if (this.appointments.length == 0) {
              this.spinner.hide();
              this.show = true;
            } else {
              this.appointments.forEach((element: any) => {
                element.appointmentDetails.schedules.forEach((appt: any) => {
                  if (
                    element.appointmentDetails.schedules[0].status !=
                      'CANCEL' &&
                    appt.status == 'FOLLOWUP'
                  ) {
                    let invalidDate = {
                      start: appt.start,
                      end: appt.end,
                      resource: appt.resource,
                      slot: appt.slot,
                      title:
                        'FollowUp ' +
                        element.parentDetails.studentFirstName +
                        ' ' +
                        element.parentDetails.studentLastName,
                      locationId: this.diagnoLocationId,
                    };
                    this.invalid.push(invalidDate);
                  }
                });
              });
              this.spinner.hide();
              this.show = true;
            }
          });
      });

    this.applyHasTextClass();
  }

  // ngAfterViewInit(){

  //   var hasInvalidtext = jQuery('.mbsc-schedule-invalid-text').text().length;
  //   console.log('loaded')
  //   if(hasInvalidtext > 0){
  //     jQuery(".mbsc-schedule-invalid-text").addClass("hasText");
  //     alert('added')
  //   }
  //   console.log(hasInvalidtext)
  // }

  private applyHasTextClass() {
    // Your jQuery code here
    jQuery(document).ready(() => {
      jQuery('.mbsc-schedule-invalid-text')
        .filter(function () {
          return jQuery(this).text().length > 0;
        })
        .addClass('hasText');
    });
  }

  addShift(shift: MbscCalendarEvent) {
    // let sd = shift.start;
    // let ed = shift.end
    var startDate = new Date(shift.start as Date);
    console.log(this.datepipe.transform(shift.start as Date, 'HH:mm'));

    var slot = this.slots.find(
      (s) =>
        s.startTime === this.datepipe.transform(shift.start as Date, 'HH:mm')
    )?.id;

    // var userTimezoneOffset = startDate.getTimezoneOffset() * 60000;
    // startDate = new Date(startDate.getTime() - userTimezoneOffset);

    var endDate = new Date(shift.end as Date);
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    // endDate = new Date(endDate.getTime() - userTimezoneOffset);
    // console.log(shift.slot);

    let s = {
      end: endDate.toISOString(),
      resource: shift.resource,
      slot: slot,
      start: startDate.toISOString(),
      title: 'Available',
      locationId: this.diagnoLocationId,
    };

    this.diagnoShifts.push(s);
  }

  closeShift() {
    jQuery('body').removeClass('timeline-event-created');
    jQuery('#diagnoSetAvailabilityClose').addClass('pointer-disable');
  }
  saveShift() {
    // this.isSaved = true;
    jQuery('body').removeClass('timeline-event-created');
    jQuery('#diagnoSetAvailabilitySubmit').removeClass('green');
    jQuery('#diagnoSetAvailabilitySubmit').addClass('grey pointer-disable');
    jQuery('#diagnoSetAvailabilityClose').addClass('pointer-disable');
    console.log(this.diagnoShifts);
    this.appointmentService
      .setDiagnosticianUnavailability(this.diagnoShifts)
      .subscribe((res) => {});
  }
  deleteShift(shift: MbscCalendarEvent): void {
    // let ed = shift.end
    // var endDate = new Date(ed  as Date)
    // var userTimezoneOffset = endDate.getTimezoneOffset() * 60000;
    // endDate = new Date(endDate.getTime() - userTimezoneOffset);
    // shift.end = endDate + ""
    // console.log(shift.start);
    //     this.diagnoShifts.forEach((item,index)=>{
    //       console.log(shift.start);
    //    if((item.end==shift.end )&&(item.start==shift.start)){
    //     delete this.diagnoShifts[index];
    //    }
    // });

    this.diagnoShifts = this.diagnoShifts.filter(
      (item) => item.end != shift.end
    );
    if (this.diagnoShifts.length == this.shiftLength) {
      jQuery('body').removeClass('timeline-event-created');
      jQuery('#diagnoSetAvailabilitySubmit').removeClass('green');
      jQuery('#diagnoSetAvailabilitySubmit').addClass('grey pointer-disable');
    }
  }
}
